module.exports = __webpack_public_path__ + "static/media/iMac_Spendwise.c76db8c9.png";